import blockquote from './blockquote';
import bigHeading from './bigHeading';
import blurb from './blurb';
import contentStack from './contentStack';
import image from './image';
import linkWithButtonBelow from './linkWithButtonBelow';
import map from './map';
import markdown from './markdown';

// internal components - not for user resuse
import hcAboutRelevant from './int_hcAboutRelevant';
import hcAboutMemorable from './int_hcAboutMemorable';
import hcAboutAlive from './int_hcAboutAlive';

export default { blockquote, bigHeading, blurb, contentStack, image, map, markdown, linkWithButtonBelow, hcAboutRelevant, hcAboutMemorable, hcAboutAlive };



// WEBPACK FOOTER //
// ./src/components/index.js